/**
 * CSV Injection (Formula Injection) protection.
 *
 * Spreadsheet applications (Excel, Google Sheets, LibreOffice Calc) interpret
 * cell values starting with certain characters as formulas or commands.
 * Malicious user input like `=CMD('calc')` or `@SUM(A1)` can execute
 * arbitrary code when the exported CSV is opened.
 *
 * OWASP ref: https://owasp.org/www-community/attacks/CSV_Injection
 */

const CSV_INJECTION_LEADING_CHARS = new Set(['=', '+', '-', '@', '\t', '\r', '\n', '|']);

export function sanitizeCSVValue(value: unknown): unknown {
  if (typeof value !== 'string' || value.length === 0) return value;
  if (CSV_INJECTION_LEADING_CHARS.has(value[0])) return `'${value}`;
  return value;
}

export function sanitizeRecordsForCSV<T extends Record<string, any>>(records: T[]): T[] {
  return records.map((record) => {
    const sanitized: Record<string, any> = { ...record };
    for (const key of Object.keys(sanitized)) {
      sanitized[key] = sanitizeCSVValue(sanitized[key]);
    }
    return sanitized as T;
  });
}
